// eslint-disable-next-line import/prefer-default-export
export const identifiers = {
  COOKIE_POLICY_ACCEPTED_NAME: 'acceptedCookies',
};

// Used to identify plot that were added to the list but not yet saved
export const temporaryPlotId = 'temp_plot_id';
export const temporaryFarmId = 'temp_farm_id';
